import NiceModal from '@ebay/nice-modal-react'
import { MODAL_LEAD_DETAILS } from '@pages/Leads/routes/Leads/components/DetailsModal'
import { LEADS } from '@routes/path'
import { ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const ModalsManager = ({ children }: { children: ReactNode }) => {
  const location = useLocation()

  /*
    when NiceModal modal is rendered as component that is unmounted on route change
    it isn't removed from the NiceModal context even though it is unmounted from the DOM
    so when we go back to the route where the modal is rendered it opens automatically.
    We need to remove it manually to prevent it from being displayed on the new route
  */
  useEffect(() => {
    if (location.pathname !== LEADS.LEADS) {
      NiceModal.remove(MODAL_LEAD_DETAILS)
    }
  }, [location.pathname, location.search])

  return children
}
